module.exports = __webpack_public_path__ + "static/media/toggle-on.5b6e4242.svg";